<template>
  <div style="display: flex;align-items: center;height: 100%;padding-top: 3px;padding-bottom: 3px;">
    <img :src="`../assets/layout/icons/${opcion.value}.png`" :alt="`idioma ${opcion.value}`" style="cursor: pointer;" v-for="opcion in opciones" :key="opcion.value" @click="$i18n.locale = opcion.value" :class="{'opcion-selected': $i18n.locale === opcion.value, 'opcion': $i18n.locale !== opcion.value}"/>
  </div>
</template>

<script>
export default {
  name: "changerLocale",
  data() {
    return {
      opciones:[
        { name: 'es', value: 'es'},
        { name: 'en', value: 'en'},
        { name: 'fr', value: 'fr' },
      ]
    };
  },
};

</script>

<style lang="scss">
.opcion{  
  transition: all 0.5s;
  margin-right: 10px;
  cursor: pointer;
  user-select: none;
  opacity: 0.5;
}

.opcion:hover, .opcion-selected{  
  opacity: 1;  
  margin-right: 10px;
  user-select: none;
}

</style>
